export const formatBRL = (value) => {
  const n = Number(value || 0);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const [y, m, d] = iso.split("T")[0].split("-");
    return `${d}/${m}/${y}`;
  } catch {
    return iso;
  }
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const monthName = (m) => {
  const names = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  return names[m - 1] || "";
};

export const monthFullName = (m) => {
  const names = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  return names[m - 1] || "";
};

export const paymentLabel = (m) => ({
  pix: "Pix", dinheiro: "Dinheiro", cartao: "Cartão", outro: "Outro",
}[m] || m);

export const statusLabel = (s) => ({
  pago: "Pago", pendente: "Pendente", parcial: "Parcial",
}[s] || s);

export const statusBadge = (s) => ({
  pago: "bg-[#E5EBE0] text-[#4F5E45] border-[#7B8B6F]/30",
  pendente: "bg-[#FCEAEA] text-[#8C4848] border-[#B86B6B]/30",
  parcial: "bg-[#F4E8D6] text-[#7B5E2E] border-[#C4A77D]/40",
}[s] || "bg-secondary");

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const onlyDigits = (s) => (s || "").replace(/\D/g, "");

// WhatsApp helpers
export const waLink = (phone, message) => {
  const digits = onlyDigits(phone);
  if (!digits) return `https://wa.me/?text=${encodeURIComponent(message)}`;
  const num = digits.length === 10 || digits.length === 11 ? `55${digits}` : digits;
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
};

export const igDMLink = (handle) => {
  const h = (handle || "").replace(/^@/, "");
  return `https://ig.me/m/${h}`;
};

export const balanceOfTattoo = (t) => {
  const price = Number(t.price || 0);
  const sinal = Number(t.sinal || 0);
  const paid = t.payment_status === "parcial" ? Number(t.paid_amount || 0) : 0;
  if (t.payment_status === "pago") return 0;
  return Math.max(price - sinal - paid, 0);
};

export const photosOf = (t) => {
  if (Array.isArray(t.photos) && t.photos.length) return t.photos;
  if (t.photo_base64) return [t.photo_base64];
  return [];
};

// Template rendering with {variable} substitution
export const renderTemplate = (template, vars = {}) => {
  if (!template) return "";
  let out = template;
  // First pass: replace tokens that have empty values with empty (and remove dangling lines)
  Object.keys(vars).forEach((key) => {
    const val = vars[key];
    if (val === "" || val === null || val === undefined) {
      // Remove whole line containing only this placeholder
      const re = new RegExp(`^.*\\{${key}\\}.*$\\n?`, "gm");
      out = out.replace(re, "");
    } else {
      const re = new RegExp(`\\{${key}\\}`, "g");
      out = out.replace(re, String(val));
    }
  });
  return out.trim();
};

export const DEFAULT_TEMPLATES = {
  appointment:
    "Oi {nome}! Confirmando seu agendamento na Julliet.Ink:\n" +
    "Data: {data}\n" +
    "Tatuagem: {descricao}\n" +
    "Local: {local}\n" +
    "Valor total: {valor}\n" +
    "Sinal recebido: {sinal}\n" +
    "Saldo no dia: {saldo}\n\n" +
    "Qualquer duvida me chama! Ate la.",
  birthday:
    "Oiii {nome}! Feliz aniversario com muito amor da Julliet.Ink! Que esse novo ciclo venha cheio de arte e luz pra voce.",
  followup:
    "Oi {nome}, tudo bem? Aqui e da Julliet.Ink - como esta sua cicatrizacao? Esta tudo certinho? Qualquer duvida me chama por aqui.",
  care:
    "Oi {nome}! Segue o material com os cuidados pos-tatuagem da Julliet.Ink:\n\n{link}\n\nQualquer duvida me chama.",
  general: "Oi {nome}! Aqui e da Julliet.Ink.",
};

export const composeAppointmentMessage = (clientName, t, template) => {
  const sinal = Number(t.sinal || 0);
  const balance = balanceOfTattoo(t);
  const vars = {
    nome: clientName,
    data: formatDate(t.date) + (t.time ? ` às ${t.time}` : ""),
    descricao: t.description || "",
    local: t.body_part || "",
    valor: formatBRL(t.price),
    sinal: sinal > 0 ? formatBRL(sinal) : "",
    saldo: balance > 0 ? formatBRL(balance) : (t.payment_status === "pago" ? "Pagamento concluido" : ""),
  };
  return renderTemplate(template || DEFAULT_TEMPLATES.appointment, vars);
};

export const composeBirthdayMessage = (clientName, template) =>
  renderTemplate(template || DEFAULT_TEMPLATES.birthday, { nome: clientName });

export const composeFollowupMessage = (clientName, template) =>
  renderTemplate(template || DEFAULT_TEMPLATES.followup, { nome: clientName });

export const composeCareMessage = (clientName, pdfUrl, template) =>
  renderTemplate(template || DEFAULT_TEMPLATES.care, { nome: clientName, link: pdfUrl });

export const composeGeneralMessage = (clientName, template) =>
  renderTemplate(template || DEFAULT_TEMPLATES.general, { nome: clientName });
